<template>
    <div class="bg cooperation">
        <headerCom></headerCom> 
        <div class="title-wrap" style="padding:60px 0 136px;background:#F4F8FC">
            <div class="name">加盟合作</div>
            <div class="interval-line"></div>
            <div class="e-name">FRANCHISE COOPERATION</div>
        </div>
        <div style="background:#F4F8FC;">
        <div class="w-body info" style="padding-bottom:75px;margin-bottom:10px;">
            <div class="mess">
                <div>
                <!-- <p>杭州卓智力创信息技术有限公司2017年6月成立，以“用户满意”为根本出发点，着眼于国内市场需求，依托团队多年来在政府、公安、交通、城管、能源、医疗、自然资源等行业的技术实践和经验积累，正以开拓创新的思路为行业用户提供最优秀、最适宣的信息技术咨询、软件开发、系统运维服务。</p>
                <p>以“卓越、智慧、合力、创新”为企业思想,以“—流产品、高效服务”为发展使命,以“用户满意”为根本出发点。</p> -->
                <img src="../assets/images/cooperation/img.png" alt="" width="667">
                </div>
            </div>
            <div class="img">
                <img src="../assets/images/cooperation/info_right.png" alt="">
            </div>
        </div>
        </div>
        <img src="../assets/images/cooperation/step.png" alt="">
        <div class="form">
            <div class="title-wrap">
                <div class="name">加盟申请</div>
                <div class="interval-line">
                    <div class="interval-line2"></div>
                </div>
                <div class="e-name">JOINING  APPLICATION</div>
            </div>
            <div class="form-wrap-bg">
                <div class="line">
                    <label>公司名称：</label>
                    <input type="text" v-model="form.companyName" placeholder="请输入公司名称">
                    <img src="../assets/images/cooperation/m.png" alt="">
                </div>
                <div class="line">
                    <label>联系人：</label>
                    <input type="text" v-model="form.contacts" placeholder="">
                    <img src="../assets/images/cooperation/m.png" alt="">
                </div>
                <div class="line">
                    <label>电话：</label>
                    <input type="text" v-model="form.telphone" placeholder="请输入您的电话">
                    <img src="../assets/images/cooperation/m.png" alt="">
                </div>
                <div class="line">
                    <label>邮箱：</label>
                    <input type="text" v-model="form.email" placeholder="请输入您的邮箱">
                    <img src="../assets/images/cooperation/m.png" alt="">
                </div>
                <div class="line" style="margin-top:50px;">
                    <label>所属行业：</label>
                    <input type="text" v-model="form.industry" placeholder="">
                    <img src="../assets/images/cooperation/m.png" alt="">
                </div>
                <div class="line">
                    <label>所在城市：</label>
                    <input type="text" v-model="form.city" placeholder="">
                    <img src="../assets/images/cooperation/m.png" alt="">
                </div>
                <div class="line">
                    <label>备注：</label>
                    <textarea name="" id="" cols="20" rows="3" v-model="form.remarks"></textarea>
                </div>
                <div class="line" style="margin-bottom:80px">
                    <label>营业执照：</label>
                    <el-upload
                        ref="fileImg"
                        :action="`${httpUrl}/file/UploadPng`"
                        list-type="picture-card"
                        :on-remove="handleRemove"
                        :on-success="successFun"
                        :file-list="imgList"
                        >
                        <img class="upload-img" src="../assets/images/cooperation/upload.png" alt="">
                    </el-upload>
                    <!-- <el-upload
                        class="avatar-uploader"
                        :action="`${httpUrl}/file/UploadPng`"
                        :show-file-list="false"
                        :on-success="successFun"
                        >
                        <img
                            v-if="form.filePath"
                            :src="httpUrl+'/disk/'+form.filePath"
                            class="avatar"
                            style="max-width:300px"
                        />
                        <img class="upload-img" v-else src="../assets/images/cooperation/upload.png" alt="">
                    </el-upload> -->
                </div>
                <div class="submit" @click="insertJoinFun()">确认提交</div>
            </div>
        </div>
    </div>
</template>
<script>
import {insertJoin} from "../api/cooperation.js";
import headerCom from "../components/header";
export default {
    name: "page",
    components: {
        headerCom
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            form:{},
            imgList:[]
        };
    },
    methods: {
         // 成功
        successFun(file, fileList){
            this.imgList.push({id:file.data.id,url:this.httpUrl+'/disk/'+file.data.filePath});
        },
        //移除
        handleRemove(file, fileList) {
            for(var i=0;i<this.imgList.length;i++){
                if(this.imgList[i].id==file.id){
                    this.imgList.splice(i,1);
                    break;
                }
            }
        },
        insertJoinFun(){
            console.log(this.form.companyName)
            if(this.form.companyName==''||this.form.companyName==undefined){
                this.$message.info('请填写公司名称！');
                return;
            }
            if(this.form.contacts==''||this.form.contacts==undefined){
                this.$message.info('请填写联系人！');
                return;
            }
            if(this.form.telphone==''||this.form.telphone==undefined){
                this.$message.info('请填写电话！');
                return;
            }
            if(this.form.email==''||this.form.email==undefined){
                this.$message.info('请填写邮箱！');
                return;
            }
            if(this.form.industry==''||this.form.industry==undefined){
                this.$message.info('请填写所属行业！');
                return;
            }
            if(this.form.city==''||this.form.city==undefined){
                this.$message.info('请填写所在城市！');
                return;
            }
            if(this.imgList.length!=0){
                let temp=[];
                for(var i=0; i<this.imgList.length;i++){
                    temp.push(this.imgList[i].id)
                }
                this.form.fileIds=temp.join(',');
                insertJoin(this.form).then(res=>{
                    if(res.code==200){
                        this.$message.success("提交成功！");
                        this.form={};
                        this.imgList=[];
                        this.$refs.fileImg.clearFiles();
                    }
                    else{
                        this.$message({
                            showClose:true,
                            message:res.message
                        })
                    }
                })
            }else{
                this.$message.info("请上传营业执照！")
            }
            
        }
    }
}
</script>
<style lang="less" scoped>
@import "../assets/css/base.less";
.avatar-uploader{
     width: 127px;
        height: 131px;
    .upload-img{
        width: 127px !important;
        height: 131px !important;
        margin-top: 15px;
    }
}
/deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 127px !important;
    height: 131px !important;
}
/deep/.el-upload--picture-card{
    background: none;
    border:0;
    width: 127px !important;
    height: 131px !important;
    img{
        width: 100% !important;
        height: 100% !important;
        margin:0 !important;
    }
}
</style>


